import { render, staticRenderFns } from "./commodityEnd.vue?vue&type=template&id=b38a7440&scoped=true&"
import script from "./commodityEnd.vue?vue&type=script&lang=js&"
export * from "./commodityEnd.vue?vue&type=script&lang=js&"
import style0 from "./commodityEnd.vue?vue&type=style&index=0&id=b38a7440&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38a7440",
  null
  
)

export default component.exports